'use client';

import UseCaseCustomerCarousel from '@/components/_rebrand/UseCaseCustomerCarousel';
import { CustomerQuotesProps } from './CustomerQuotes.types';
import { mapQuotesToCarouselCustomers } from './CustomerQuotes.utils';

const CustomerQuotes = ({ entry }: CustomerQuotesProps) => {
  const customers = mapQuotesToCarouselCustomers(entry.individualCustomerQuotes);

  return (
    <UseCaseCustomerCarousel
      title={entry.customerQuotesHeadline}
      customers={customers}
      masterMarginsTop={false}
      masterMarginsBottom={false}
    />
  );
};

export default CustomerQuotes;
